import { render, staticRenderFns } from "./InputCupon.vue?vue&type=template&id=70cf66cd"
import script from "./InputCupon.vue?vue&type=script&lang=js"
export * from "./InputCupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports